export const suggestions = [
  {
    title: 'Product & Design',
    shortlinks: ['brand', 'templates', 'design-system', 'ui-components'],
  },
  {
    title: 'Engineering',
    shortlinks: ['aws', 'logs', 'apm', 'bugs'],
  },
  {
    title: 'Marketing',
    shortlinks: ['leads', 'emails', 'keywords', 'templates'],
  },
  {
    title: 'Sales',
    shortlinks: ['deals', 'pipeline', 'contracts', 'reps'],
  },
  {
    title: 'HR',
    shortlinks: ['handbook', 'open-roles', 'interviews', 'orgchart'],
  },
  {
    title: 'Support',
    shortlinks: ['inbox', 'issues', 'requests', 'open-tickets'],
  },
]
